import React, { useEffect, useState } from 'react'
import { Button, Tooltip } from 'antd'
import { CloseOutlined, PauseOutlined } from '@ant-design/icons'
import { getRemainingTime, isItemSnoozed } from './utils'
import { AvailabilityAction } from './types'

interface SnoozeButtonProps {
  itemId: string
  name: string
  unsnoozeAt: string | null
  onClickHandler: (action: AvailabilityAction, id: string, name: string) => void
  loading: boolean
  disabled: boolean
  dataTestId: string
}

const SnoozeButton = ({
  itemId,
  name,
  unsnoozeAt,
  onClickHandler,
  loading,
  disabled,
  dataTestId
}: SnoozeButtonProps) => {
  const [isSnoozed, setIsSnoozed] = useState<boolean>(isItemSnoozed(unsnoozeAt))
  const [buttonText, setButtonText] = useState<string>(
    isSnoozed ? getRemainingTime(unsnoozeAt) : 'Snooze'
  )

  useEffect(() => {
    if (!isSnoozed) return

    const intervalId = setInterval(() => {
      if (!isItemSnoozed(unsnoozeAt)) {
        setButtonText('Snooze')
        setIsSnoozed(false)
      } else {
        setButtonText(getRemainingTime(unsnoozeAt))
      }
    }, 1000)

    return () => clearInterval(intervalId)
  }, [isSnoozed, unsnoozeAt])

  return (
    <Tooltip title={buttonText}>
      <Button
        block
        type='primary'
        loading={loading}
        disabled={disabled}
        icon={isSnoozed ? [] : <PauseOutlined />}
        data-testid={dataTestId}
        className={isSnoozed ? '_max-w-xs' : '-default-secondary _max-w-xs'}
        style={{
          display: 'flex',
          justifyContent: 'center'
        }}
        onClick={() =>
          onClickHandler(
            isSnoozed ? AvailabilityAction.UNSNOOZE : AvailabilityAction.SNOOZE,
            itemId,
            name
          )
        }
      >
        {isSnoozed && (
          <CloseOutlined style={{ display: 'flex', alignItems: 'center' }} />
        )}
      </Button>
    </Tooltip>
  )
}

export default SnoozeButton
